import {AttrsSchema, Component} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {panel2react} from 'common/util/react';

import {template} from './template';
import css from './index.inline.styl';

export interface ListItemAttrs {
  active?: boolean;
  disabled?: boolean;
  static?: boolean;
}

export interface ListItemProps {
  attrs?: ListItemAttrs;
}

export class ListItem extends Component<EmptyObj, ListItemAttrs> {
  static get attrsSchema(): AttrsSchema<ListItemAttrs> {
    return {
      ...super.attrsSchema,
      active: `boolean`,
      disabled: `boolean`,
      static: `boolean`,
    };
  }

  get config() {
    return {
      css,
      template,
      useShadowDom: true,
    };
  }
}

export const ListItemEl = defineAndMakeJsxFactory<ListItemProps>(`mp-list-item`, ListItem);
export const ListItemReact = panel2react<ListItemProps>(`mp-list-item`, ListItem);
